var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sidebar-container" },
    [
      _c(
        "div",
        {
          staticClass: "create-button-container",
          style: {
            "padding-top": _vm.createButtonTitle != "" ? "40px" : "25px",
            "background-color": _vm.variables.menuBg,
          },
        },
        [
          _vm.createButtonTitle != ""
            ? _c(
                "el-popover",
                {
                  attrs: {
                    offset: _vm.addOffset,
                    "visible-arrow": false,
                    disabled: !_vm.$slots.add,
                    placement: "right",
                    "popper-class": "no-padding-popover",
                    trigger: "hover",
                  },
                },
                [
                  _vm._t("add"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "create-button",
                      attrs: { slot: "reference" },
                      on: { click: _vm.quicklyCreate },
                      slot: "reference",
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.buttonCollapse,
                              expression: "!buttonCollapse",
                            },
                          ],
                          staticClass: "button-name",
                        },
                        [_vm._v(_vm._s(_vm.createButtonTitle))]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.buttonCollapse,
                            expression: "!buttonCollapse",
                          },
                        ],
                        staticClass: "button-line",
                      }),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "button-mark",
                        class: _vm.createButtonIcon,
                      }),
                    ]
                  ),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-scrollbar",
        {
          style: {
            "border-right-color": _vm.variables.menuBg,
            "padding-top": _vm.createButtonTitle != "" ? "90px" : "40px",
          },
          attrs: { "wrap-class": "scrollbar-wrapper" },
        },
        [
          _c(
            "el-menu",
            {
              staticClass: "el-menu-vertical",
              style: { paddingBottom: _vm.paddingBottom },
              attrs: {
                "default-active": _vm.activeMenu,
                collapse: _vm.collapse,
                "background-color": _vm.variables.menuBg,
                "text-color": _vm.variables.menuText,
                "active-text-color": _vm.variables.menuActiveText,
                mode: "vertical",
              },
              on: { select: _vm.handleSelect },
            },
            _vm._l(_vm.items, function (route, index) {
              return _c("sidebar-item", {
                key: `${route.path}${index}`,
                attrs: {
                  item: route,
                  collapse: _vm.collapse,
                  "base-path": route.path,
                  "active-menu": _vm.activeMenu,
                },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("bottom"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sidebar-bottom",
          style: { "background-color": _vm.variables.menuBg },
        },
        [
          _c("div", { staticClass: "sidebar-bottom-content" }, [
            !_vm.collapse
              ? _c("div", { staticClass: "copyright" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/img/favicon.png"),
                      width: "20px",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Power by 悟空")]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("img", {
              staticClass: "collapse-button",
              class: { "is-close": _vm.collapse },
              style: { right: _vm.buttonCollapse ? "3px" : "0" },
              attrs: {
                src: require("@/assets/img/collapse_white.png"),
                alt: "",
              },
              on: { click: _vm.toggleSideBarClick },
            }),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }